import React, { Component } from 'react';
import { omit } from 'lodash-es';
import PropTypes, { string } from 'prop-types';
import MaxLengthExceeded from '../MaxLengthExceeded';

const preventSubmitOnEnter = (e) => (
  e.key === 'Enter' && e.preventDefault()
);

class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxLengthExceeded: false
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const exceeded = event.target.value.length >= this.props.maxLength;
    if (this.state.maxLengthExceeded !== exceeded) {
      this.setState({ maxLengthExceeded: exceeded });
    }
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  render() {
    const inputProps = omit(this.props, ['translate', 'onChange', 'onKeyPress', 'textarea', 'dataCy']);
    const { textarea, maxLength, dataCy } = this.props;
    return (
      <div>
        {textarea
          ? (
            <textarea
              {...inputProps}
              onChange={this.handleChange}
              data-cy={dataCy}
            />
          )
          : (
            <input
              {...inputProps}
              type="text"
              onKeyPress={preventSubmitOnEnter}
              onChange={this.handleChange}
              data-cy={dataCy}
            />
          )}
        {this.state.maxLengthExceeded
        && <MaxLengthExceeded maxLength={maxLength} />}
      </div>
    );
  }
}

const { func, number, bool } = PropTypes;

TextInput.propTypes = {
  onChange: func,
  maxLength: number.isRequired,
  textarea: bool,
  dataCy: string
};

TextInput.defaultProps = {
  onChange: null,
  textarea: false,
  dataCy: null
};

export default TextInput;
